<template>
  <div
    v-if="isBulkDiscount"
    class="bulk-discount"
    @click="showNewMessage()"
  >
    <img
      class="bulk-discount__image"
      src="@/assets/offer/apply-now.png"
      alt=""
    >
    <p class="bulk-discount__title">
      You’ve qualified for bulk discounts. Would you like to apply?
    </p>
    <Icon
      class="bulk-discount__icon"
      name="arrow-right-l-2"
    />
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { useIntercom } from '@/hooks/useIntercom'
import { useBulkDiscount } from '@/views/Carts/hooks/useBulkDiscount'

const { isBulkDiscount } = useBulkDiscount()
const { showNewMessage } = useIntercom()
</script>

<style lang="less" scoped>
.bulk-discount {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(90deg, #141414 0%, #523C2A 100%);
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;

  &__image {
    width: 36px;
    height: 36px;
  }

  &__title {
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    color: #FFFFFF;
  }

  &__icon {
    flex-shrink: 0;
    font-size: 14px;
    color: #FFFFFF;
  }
}
</style>
